import { Gamepad2, Music, Tv } from "lucide-react";
import { sfx, SOUND_STYLES, type SoundStyle } from "../lib/sound";
import { useData } from "../context/DataContext";

const ICONS: Record<SoundStyle, any> = { gameshow: Tv, arcade: Gamepad2, orchestra: Music };

export function SoundStylePicker({ value, onChange, place, compact = false, disabled = false }: { value: string; onChange: (s: SoundStyle) => void; place: string; compact?: boolean; disabled?: boolean }) {
  const { prefs, setPrefs } = useData();
  const choose = (s: SoundStyle) => {
    if (!prefs.sound_effects) setPrefs({ sound_effects: true });
    sfx.unlock();
    sfx.fanfare(s);
    onChange(s);
  };
  return (
    <div className={compact ? "flex flex-wrap justify-center gap-2" : "grid gap-2 sm:grid-cols-3"} data-testid={`sound-style-picker-${place}`}>
      {SOUND_STYLES.map((s) => {
        const Icon = ICONS[s.id];
        const active = value === s.id;
        return (
          <button key={s.id} type="button" disabled={disabled} onClick={() => choose(s.id)} data-active={active} aria-pressed={active} data-testid={`sound-style-${place}-${s.id}`}
            className={compact
              ? "chip inline-flex items-center gap-1.5"
              : "rounded-2xl border-[3px] border-ink bg-white p-3 text-left transition-colors data-[active=true]:bg-pop-teal disabled:opacity-50"}>
            <span className="inline-flex items-center gap-1.5 font-display font-bold uppercase"><Icon className="h-4 w-4" strokeWidth={2.5} />{s.label}</span>
            {!compact && <span className="mt-0.5 block text-xs font-semibold text-zinc-600">{s.blurb}</span>}
          </button>
        );
      })}
    </div>
  );
}
